export const requestState ={
    0:'جدید',
    1:'درخواست پرداخت پذیرش',
    2:'درخواست پرداخت',
    3:'پرداخت پذیرش',
    4:'پرداخت شده',
    5:'پذیرش اولیه',
    6:'پذیرش شده',
    7:'انصراف',
    8:'حذف شده',
    9:'صدور گواهی شده'
} 

export const paymentState ={
    0:'پرداخت نشده',
    1:'درخواست داده شده',
    2:'لغو شده',
    3:'پرداخت شده',
    4:'خطا'
}
export const paymentType ={
    0:'تعیین نشده',
    1:'درگاه پیامکی پانو',
    2:'درگاه اینترنتی پانو',
    3:'دستگاه کارت خوان',
    4:'پرداخت از طریق واریز وجه',
    5:'پرداخت قبض'
}

export const payType={
    0:'پرداخت کامل',
    3:'پرداخت با تخفیف'
}

export const identityCodeStatus ={
    0:'دارای شناسنامه',
    1:'عدم دسترسی به شناسنامه',
    2:'فاقد شناسنامه'
    
}

export const enumResidenceStatus ={
    0:'ایرانی',
    1:'غیر ایرانی',
    2:'نامشخص'
}

export const enumReferTypes ={
    0:'عادی',
    1:'خودکشی',
    2:'خودزنی',
    3:'نزاع',
    4:'تصادف',
   
}


export const enumEducationStatus ={
    0:'بی سواد',
    1:'ابتدایی/نهضت',
    2:'راهنمایی',
    3:'دبیرستان',
    4:'دانشگاهی',
    5:'دکترای تخصصی و فوق دکترا',
    6:'سایر',
}

export const enumDeathLocation ={
    0:'منزل',
    1:'بیمارستان/مراکز جراحی محدود',
    2:'مرکز درمان سرپایی',
    3:'معابر و اماکن عمومی',
    4:'آسایشگاه',
    5:'نامشخص',
    6:'سایر',
}


export const enumWomanPrognancyStatus ={
    0:'باردار نبوده است(در طی 42 روز پس از ختم بارداری هم فوت نکرده است(',
    1:'باردار بوده است',
    2:'در حین زایمان فوت کرده است',
    3:'طی 42 روز پس از ختم بارداری فوت کرده است',
    4:'وضعیت بارداری نا مشخص است'
}

export const enumYesNo ={
    0:'ندارد',
    1:'دارد',
   
}

export const enumYesNoGenesis ={
    0:'ندارد',
    1:'دارد',
    2:'درحال تکوین',
   
}

export const enumFinalResult ={
    0:'صدور جواز دفن',
    1:'ارجاع به پزشکی قانونی',
  
}

export const enumMessageState ={
    0:'جدید',
    1:'خوانده شده',
  
}


export const enumGender ={
    1:'مرد',
    2:'زن',
   
}



export const enumNationalCodeStatus ={
    0:'ایرانی',
    1:'خارجی یا اتباع'
}
  


  
